<template>
  <div>
    <!-- <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <vs-button color="primary" icon="update" icon-after @click="synchronizeWebmais('all')">Sincronizar Todos</vs-button>
      </div>
    </div>

    <div class="vx-row">

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UsersIcon" :statistic="totalCustomers" statisticTitle="Clientes" type='area'>
          Ultima Atualização: {{lastUpdates('clientes')}}
          <vs-button color="primary" icon="update" type="border" icon-after @click="synchronizeWebmais('customers')">Sincronizar</vs-button>
        </statistics-card-line>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="ArchiveIcon" :statistic="totalProducts" statisticTitle="Produtos" color='success' type='area'>
          Ultima Atualização: {{lastUpdates('produtos')}}
          <vs-button color="primary" icon="update" type="border" icon-after @click="synchronizeWebmais('products')">Sincronizar</vs-button>
        </statistics-card-line>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="FileTextIcon" :statistic="totalOrders" statisticTitle="Pedidos" color='warning' type='area'>
          Ultima Atualização: {{lastUpdates('pedidos')}}
          <vs-button color="primary" icon="update" type="border" icon-after @click="synchronizeWebmais('orders')">Sincronizar</vs-button>
        </statistics-card-line>
      </div>
    </div>

    {{this.$store.state.user}}-->

  </div>
</template>


<script>
//import { baseApiUrl, userKey, avatarPhoto } from "@/global";
import helpers from "@/helpers";
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
export default {
  components: { StatisticsCardLine },
  data() {
    return {
      backgroundLoading: "primary",
      colorLoading: "#fff"
    };
  },
  computed: {
    totalCustomers() {
      return this.$store.state.customers.length
    },
    totalProducts() {
      return this.$store.state.products.length
    },
    totalOrders() {
      return this.$store.state.orders.length
    },
  },
  methods: {
    lastUpdates(type) {
      const lastUpdate = this.$store.state.lastUpdates[type]
      return helpers.dateHelper.formatDateTimeToPTBR(lastUpdate)
    },
    async synchronizeWebmais(type) {
      await this.$store.dispatch("fetchSynchronizeWebmais", { type, notify: this.$vs.notify, loading: this.$vs.loading })
      await this.$store.dispatch("fetchLastUpdates")
    }
  },
  async created() {
    this.$vs.loading()
    await this.$store.dispatch("fetchLastUpdates")
    await this.$store.dispatch("fetchProductsItems")
    await this.$store.dispatch("fetchCustomersItems")
    await this.$store.dispatch("fetchOrdersItems")
    this.$vs.loading.close()
  }
};

</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media(max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */

</style>
